exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-control.input.form-text-error{border-width:1px;border-color:#dd0342}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/form/FormText/FormText.scss
 ** module id = 1247
 ** module chunks = 0
 **/